export default class Interval {
  constructor(startTime, endTime, duration) {
    this.startTime = startTime
    this.endTime = endTime
    this.duration = duration
  }
}
